<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.rfm-analysis' | transloco }}
    </h3>
    <span></span>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body rfm-body">
          <hx-loader *ngIf="!isMarketing" [length]="list.length" [isLoading]="isloading.rfm"></hx-loader>
          <div class="hx-filters m--margin-bottom-50" *ngIf="isMarketing">
            <div class="filter">
              <small>{{ 'rfm-analysis.stores' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [marketing]="true" [multiple]="true"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'rfm-analysis.date' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'rfm-analysis.frequency' | transloco }}</small>
              <input type="text" required [(ngModel)]="params.maxFrequency" name="maxFrequency" class="form-control m-input"
                     [placeholder]="'rfm-analysis.frequency' | transloco">
            </div>

            <div class="filter">
              <small>{{ 'rfm-analysis.monetary' | transloco }}</small>
              <input type="text" required [(ngModel)]="params.maxMonetary" name="maxMonetary" class="form-control m-input"
                     [placeholder]="'rfm-analysis.monetary' | transloco">
            </div>

            <div class="filter m--margin-top-20">
              <button class="btn btn-outline-info" type="button" (click)="getTypeFilter()" [disabled]="isloading.rfm"
                      [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isloading.rfm}">
                {{ 'ord.order-list.search' | transloco }}
              </button>
            </div>
          </div>


          <div class="container-common" *ngIf="list.length && !isloading.rfm">
            <div class="content">
              <div class="title">{{ 'rfm-analysis.recency' | transloco }}</div>
              <div class="container">
                <div class="container">
                  <div class="number-first">1</div>
                  <div class="text">
                    <span class="count-first">{{ recencySegment1Count | number }}</span>
                    <span class="description-first">{{ 'rfm-analysis.upTo' | transloco }} {{ recency40 | date:'dd.MM.yyyy' }}</span>
                  </div>
                </div>

                <div class="container">
                  <div class="number-second">2</div>
                  <div class="text">
                    <span class="count-second">{{ recencySegment2Count | number }}</span>
                    <span class="description-second">{{ recency40 | date:'dd.MM.yyyy' }} – {{ recency90 | date:'dd.MM.yyyy' }}</span>
                  </div>
                </div>

                <div class="container">
                  <div class="number-third">3</div>
                  <div class="text">
                    <span class="count-third">{{ recencySegment3Count | number }}</span>
                    <span class="description-third">{{ 'rfm-analysis.after' | transloco }} {{ recency90 | date:'dd.MM.yyyy' }}</span>
                  </div>
                </div>
              </div>

              <div class="title">{{ 'rfm-analysis.frequency' | transloco }}</div>
              <div class="container">
                <div class="container">
                  <div class="number-first">1</div>
                  <div class="text">
                    <span class="count-first">{{ frequencySegment1Count | number }}</span>
                    <span class="description-first">{{ 'rfm-analysis.upTo' | transloco }} {{ frequency40 }} {{ 'rfm-analysis.purchases' | transloco }}</span>
                  </div>
                </div>

                <div class="container">
                  <div class="number-second">2</div>
                  <div class="text">
                    <span class="count-second">{{ frequencySegment2Count | number }}</span>
                    <span class="description-second">{{ 'rfm-analysis.from' | transloco }} {{ frequency40 }} {{ 'rfm-analysis.upTo' | transloco }} {{ frequency90 }} {{ 'rfm-analysis.purchases' | transloco }}</span>
                  </div>
                </div>

                <div class="container">
                  <div class="number-third">3</div>
                  <div class="text">
                    <span class="count-third">{{ frequencySegment3Count | number }}</span>
                    <span class="description-third">{{ frequency90 }} {{ 'rfm-analysis.more' | transloco }} {{ 'rfm-analysis.purchases' | transloco }}</span>
                  </div>
                </div>
              </div>

              <div class="title">{{ 'rfm-analysis.monetary' | transloco }}</div>
              <div class="container">
                <div class="container">
                  <div class="number-first">1</div>
                  <div class="text">
                    <span class="count-first">{{ monetarySegment1Count | number }}</span>
                    <span class="description-first">{{ 'rfm-analysis.upTo' | transloco }} {{ monetary33 | currency:currency }}</span>
                  </div>
                </div>

                <div class="container">
                  <div class="number-second">2</div>
                  <div class="text">
                    <span class="count-second">{{ monetarySegment2Count | number }}</span>
                    <span class="description-second">{{ 'rfm-analysis.from' | transloco }} {{ monetary33 | currency:currency }} {{ 'rfm-analysis.upTo' | transloco }} {{ monetary66 | currency:currency }}</span>
                  </div>
                </div>

                <div class="container">
                  <div class="number-third">3</div>
                  <div class="text">
                    <span class="count-third">{{ monetarySegment3Count | number }}</span>
                    <span class="description-third">{{ 'rfm-analysis.more' | transloco }} {{ monetary66 | currency:currency }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-wrapper" *ngIf="list.length">
              <table class="table">
                <tr>
                  <th>{{ 'rfm-analysis.segment' | transloco }}</th>
                  <th>{{ 'rfm-analysis.amount' | transloco }}</th>
                </tr>
                <tr *ngFor="let pp of list">
                  <td>{{ pp.rfmSegment | number }}</td>
                  <td>{{ pp.totalRfmCustomers | number }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="m--margin-top-50" *ngIf="list.length && !isloading.rfm">
            <table class="table">
              <tr>
                <th>{{ 'rfm-analysis.segment' | transloco }}</th>
                <th>{{ 'rfm-analysis.rfmCode' | transloco }}</th>
                <th>{{ 'rfm-analysis.clientAmount' | transloco }}</th>
                <th>{{ 'rfm-analysis.spendMoneyTotal' | transloco }}</th>
                <th>{{ 'rfm-analysis.clientAvgTotal' | transloco }}</th>
                <th>{{ 'rfm-analysis.orderTotal' | transloco }}</th>
                <th>{{ 'rfm-analysis.clientOrderAvgAmount' | transloco }}</th>
              </tr>
              <tr *ngFor="let pp of rfmDataList">
                <td>
                  <a [title]="pp.segments" [routerLink]="['segments']" [queryParams]="{ segments: pp.segments.join(','), dateFrom: params.date.from, dateTo: params.date.to, storeIds: (params.storeIds.length) ? params.storeIds?.join(',') : [], maxFrequency: params.maxFrequency, maxMonetary: params.maxMonetary }">
                    {{ pp.name }}
                  </a>
                </td>
                <td>{{ pp.segments }}</td>
                <td>{{ pp.clientAmount || 0 | number }}</td>
                <td>{{ pp.spendMoneyTotal || 0 | number }}</td>
                <td>{{ pp.clientAvgTotal || 0 | number }}</td>
                <td>{{ pp.orderTotalAmount || 0 | number }}</td>
                <td>{{ pp.clientOrderAvgTotal || 0 | number }}</td>
              </tr>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
